import Flickity from 'flickity';

export default class InspirationGallery {
  constructor() {
    const $els = document.querySelectorAll('.js-inspiration-gallery');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.activeClass = 'is-active';

    this.$tabs = $el.querySelectorAll('.js-tab');
    this.$carousel = $el.querySelector('.js-carousel');
    this.$nextBtn = $el.querySelector('.js-next-btn');
    this.$prevBtn = $el.querySelector('.js-prev-btn');

    this.flickity = new Flickity(this.$carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: false,
      wrapAround: true,
    });

    this.flickity.on('select', this.onSelect.bind(this));

    this.$nextBtn?.addEventListener('click', this.next.bind(this));
    this.$prevBtn?.addEventListener('click', this.prev.bind(this));

    this.$tabs.forEach(($tab, index) => {
      $tab.addEventListener('click', this.goToSlide.bind(this, $tab, index));
    });
  }

  /**
   * @function next
   * @param {Event} e
   * @returns void
   * Goes to next slide in carousel
   */
  next(e) {
    if (!this.flickity) return;

    e.preventDefault();
    this.flickity.next();
  }

  /**
   * @function prev
   * @param {Event} e
   * @returns void
   * Goes to previous slide in carousel
   */
  prev(e) {
    if (!this.flickity) return;

    e.preventDefault();
    this.flickity.previous();
  }

  /**
   * @function goToSlide
   * @param {HTMLButtonElement} $tab tab that has been clicked
   * @param {Number} index slide index
   * @returns void
   * Goes to specific slide in carousel based on index
   */
  goToSlide($tab, index = 0) {
    if (!this.flickity || !$tab) return;

    this.$tabs.forEach($tab => $tab.ariaSelected = false);
    $tab.ariaSelected = true;

    this.flickity.select(index);
  }

  /**
   * @function onSelect
   * @param {Number} index
   * Fired when the Flickity slide changes
   */
  onSelect(index) {
    this.$tabs.forEach($tab => $tab.ariaSelected = false);
    this.$tabs[index] && (this.$tabs[index].ariaSelected = true);
  }
}
